import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2621f2bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { Input, InputNumber } from 'ant-design-vue';
import { Select } from '@/components';
import { onMounted, reactive, watch, ref } from 'vue';
import countrysArr from './countrys-info';
export type PhoneInfo = {
  callingCode?: string;
  number?: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    placeholder: {},
    disabled: { type: Boolean },
    codeDisable: { type: Boolean },
    value: {}
  },
  emits: ["update:value", "change"],
  setup(__props: any, { emit }) {

const props = __props;

const InputGroup = Input.Group;
const SearchSelect = Select.Search;
const SelectOption = Select.Option;
const dropdownWidth = ref<number>();
const countrys = ref<
  Array<{
    name: string;
    flag: string;
    callingCode?: string;
  }>
>(countrysArr);



function changeSelect(str: string) {
  change(str, 'callingCode');
}
function changeInput(str: any) {
  change(str + '', 'number');
}
function change(str: string, key: 'number' | 'callingCode') {
  let temp = { ...props.value };
  temp[key] = str;
  emit('update:value', temp);
  emit('change', temp);
}

onMounted(() => {
  dropdownWidth.value = Number(document.querySelector('.phone-select')?.clientWidth);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(InputGroup), {
    class: "phone-select",
    compact: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(SearchSelect), {
        value: _ctx.value.callingCode,
        disabled: _ctx.disabled || _ctx.codeDisable,
        width: 130,
        "dropdown-style": { maxHeight: '250px' },
        "dropdown-width": dropdownWidth.value,
        "show-icon": "",
        "show-allow": "",
        onChange: changeSelect
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countrys.value, ({ name, flag, callingCode }) => {
            return (_openBlock(), _createBlock(_unref(SelectOption), {
              key: name + callingCode,
              value: callingCode
            }, {
              icon: _withCtx(() => [
                _createElementVNode("img", {
                  class: "flags",
                  src: require(`@/assets/country-flags/${flag}.svg`),
                  alt: "sd"
                }, null, 8, _hoisted_1)
              ]),
              prefix: _withCtx(() => [
                _createTextVNode(_toDisplayString(name), 1)
              ]),
              default: _withCtx(() => [
                _createTextVNode(" (+" + _toDisplayString(callingCode) + ") ", 1)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value", "disabled", "dropdown-width"]),
      _createVNode(_unref(InputNumber), {
        value: _ctx.value.number,
        disabled: _ctx.disabled,
        size: "large",
        style: {"flex":"1"},
        placeholder: _ctx.placeholder,
        type: "number",
        controls: false,
        onChange: changeInput
      }, null, 8, ["value", "disabled", "placeholder"])
    ]),
    _: 1
  }))
}
}

})